import React, { useState } from "react";
import Select from "react-select";
import { Button, Button2, theme } from "./CSS";

const SceneSettings = (props) => {
	const options = [
		{ value: "1", label: "Kanji-EN (N5)" },
		{ value: "2", label: "Kanji-EN (N4)" },
	];

	const [selectedOption, setSelectedOption] = useState({
		value: "1",
		label: "Kanji-EN",
	});

	function DoClick() {
		window.$mode = selectedOption.value;
		// alert("You clicked me!" + selectedOption.value);
		props.parentCallback(0);
	}

	return (
		<>
			<table width="100%">
				<tr>
					<td>
						<h3>Mode:&nbsp;</h3>
					</td>
					<td width="100%">
						<Select
							id="selectMode"
							name="selectMode"
							options={options}
							value={props.number}
							// onChange={handleChange}
							// defaultValue={{ value: "1", label: "Kanji-EN" }}
							defaultValue={selectedOption}
							onChange={setSelectedOption}
						/>
					</td>
				</tr>
			</table>
			<table width="100%">
				<tr>
					<td>
						<Button onClick={() => DoClick()}>Apply Settings</Button>
					</td>
					<td width="120">
						<a href="https://p-library.com/a/drawword/" target="_blank">
							<Button2 theme="black">How to Play</Button2>
						</a>
					</td>
				</tr>
			</table>
			<div>&nbsp;</div>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<font size="2">Kotoba-chan&nbsp;</font>
				<font size="1">extension by Pujana P</font>
			</div>
		</>
	);
};

export default SceneSettings;
